import React from 'react';
/**
 * Hook to handle ReactNode validation errors from intl.formatMessage().
 * Wraps validation functions to intercept ReactNode returns and store them,
 * while returning a placeholder string to react-hook-form. The real ReactNode
 * is extracted when displaying the error.
 */ export const useWrappedFormValidation = (rules)=>{
    const reactNodeErrorRef = React.useRef(null);
    const wrappedRules = React.useMemo(()=>{
        if (!(rules === null || rules === void 0 ? void 0 : rules.validate)) {
            return rules;
        }
        const wrapValidateFn = (fn)=>{
            return async (value, formValues)=>{
                const result = await fn(value, formValues);
                // React-hook-form only accepts string errors, not ReactNodes. When validation
                // returns a ReactNode (e.g., from intl.formatMessage), we store it in a ref
                // and return a placeholder string to signal validation failure. The placeholder
                // is never shown to users as extractError() retrieves the real ReactNode.
                if (/*#__PURE__*/ React.isValidElement(result)) {
                    reactNodeErrorRef.current = result;
                    return 'Error';
                }
                // Clear stored error if validation passed
                if (result === undefined || result === true) {
                    reactNodeErrorRef.current = null;
                }
                return result;
            };
        };
        const validate = typeof rules.validate === 'function' ? wrapValidateFn(rules.validate) : Object.fromEntries(Object.entries(rules.validate).map(([key, fn])=>[
                key,
                wrapValidateFn(fn)
            ]));
        return {
            ...rules,
            validate
        };
    }, [
        rules
    ]);
    const extractError = React.useCallback((errorMessage)=>{
        var _reactNodeErrorRef_current;
        // Always prefer ReactNode from ref if it exists
        return (_reactNodeErrorRef_current = reactNodeErrorRef.current) !== null && _reactNodeErrorRef_current !== void 0 ? _reactNodeErrorRef_current : errorMessage;
    }, []);
    return {
        wrappedRules,
        extractError
    };
};

//# sourceMappingURL=useWrappedFormValidation.js.map